import _ from 'lodash'
import moment from 'moment'
import React, { createRef } from 'react'

import { ability } from '../../../../ability'
import { Action, Permission } from '../../../../ability/types'
import { withLegacyRouter } from '../../../../decorators'
import { GeneralDocuments } from '../../../../lib/Codes'
import DownloadLink from '../../../shared/DownloadLink/DownloadLink'
import {
  bindTargetMixin,
  CheckboxInput,
  CancelButton,
  DateInput,
  FileInput,
  SaveButton,
  SelectInput,
  TextInput,
  documentsFileTypes
} from '../../../shared/FormBuilder'
import { Paper, RequiredSpan } from '../../../shared/NarusMaterial'

@withLegacyRouter
export default class DocumentsForm extends bindTargetMixin(React.Component) {
  constructor (props) {
    super(props)
    this.fileInputRef = createRef()
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  componentDidMount () {
    this.setState({
      isSubmitting: false
    })
  }

  getValue = () => ({
    ...this.state.value,
    uploadedBy: {
      reference: `Practitioner/${this.props.currentUser.id}`,
      display: this.props.currentUser.display
    },
    indexed: moment()
  })

  handleSubmit () {
    const { onSubmit } = this.props
    const value = this.getValue()
    const fileInput = this.fileInputRef.current
    let uploadPromise = null

    if (fileInput) {
      if (fileInput.isFileSelected()) {
        uploadPromise = fileInput.doUpload().then(uploadedFiles => {
          value.attachedFileMeta = _.get(uploadedFiles, 'files.file0')
        })
      } else {
        uploadPromise = null
      }
    } else {
      uploadPromise = Promise.resolve(value.attachedFileMeta)
    }

    if (uploadPromise) {
      this.setState({
        isSubmitting: true,
        errors: null
      })

      uploadPromise
        .then(() => {
          if (onSubmit) {
            onSubmit(value)
          }
        })
        .catch(e => {
          this.setState({
            isSubmitting: false,
            errors: {
              fileInput: [ e.message ]
            }
          })
        })
    } else {
      this.setState({
        errors: {
          fileInput: [
            typeof fileInput.supportedFileTypes === 'function'
              ? `Please, select a valid file (${fileInput.supportedFileTypes().join(', ')}).`
              : 'Please, select a valid file'
          ]
        }
      })
    }
  }

  render () {
    const { onCancel } = this.props
    const {
      value: { file, attachedFileMeta, type, mPower }
    } = this.state
    let fileFieldOrDownloadLink = null

    let disableForMpower = false

    if (file) {
      disableForMpower = file.size > 10485760 || documentsFileTypes[file.type]
      _.set(this.state, 'value.mPower', disableForMpower || mPower)
    }

    const formEnabled = (file || attachedFileMeta) && type

    if (this.props.value.id) {
      const meta = this.state.value.attachedFileMeta

      fileFieldOrDownloadLink = (
        <DownloadLink
          meta={meta}
          patientId={this.props.params.id}
          type='DocumentReference'
          clientName={this.props.params.clientName}
        />
      )
    } else {
      fileFieldOrDownloadLink = (
        <FileInput
          name='file'
          fileRef={this.fileInputRef}
          label='File to upload'
          errors={file && _.get(this.state, 'errors.fileInput')}
          fileTypes='docs'
          maxSize={104857600}
        />
      )
    }

    const canReadClinical = ability.can(Action.READ, Permission.IGAO_CLINICAL)
    const nonClinicalDocs = [
      'Bill Image',
      'Provider List',
      'Explanation of Benefits',
      'Insurance Card',
      'Verification of Benefits',
      'Policy Information',
      'Other - Non-clinical'
    ]

    return (
      <div className='margin-top margin-bottom'>
        <Paper>
          <div className='row'>
            <div className='col-xs-12 col-sm-6'>
              {fileFieldOrDownloadLink}
              <div style={{ marginTop: '0.5em' }}>
                {formEnabled ? null : <RequiredSpan text='Field' />}
              </div>
            </div>
            <div className='col-xs-12 col-sm-6' />

            <div className='col-xs-12 col-sm-6'>
              <SelectInput
                options={canReadClinical ? GeneralDocuments : GeneralDocuments.filter(item => nonClinicalDocs.includes(item.code))}
                label='Type'
                name='type'
                required
              />
            </div>

            <div className='col-xs-12 col-sm-6 mui-date-picker-extended'>
              <DateInput
                label='Document Creation Date'
                name='created'
                maxLength={128}
              />
            </div>

            <div className='col-xs-12 col-sm-12'>
              <TextInput
                label='Description'
                name='description'
              />
            </div>
          </div>

          <div className='col-xs-12 col-sm-6'>
            <CheckboxInput
              label='Not accessible from mPower'
              name='mPower'
              disabled={disableForMpower}
            />
          </div>

          <div
            className='row end-xs'
            style={{ marginTop: '20px' }}
          >
            <div className='col-xs-12'>
              <CancelButton
                noGlobal
                onClick={onCancel}
              />
              <SaveButton
                disabled={!formEnabled || this.state.isSubmitting}
                onClick={this.handleSubmit}
              />
            </div>
          </div>
        </Paper>
      </div>
    )
  }
}
